var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{ref:"m_common",class:`m_common detect_deviece_${_vm.deviceType} state_${_vm.deviceType}`},[_c('HeadBar',{attrs:{"title":_vm.title,"deviceType":_vm.deviceType},on:{"go-back":_vm.goback}}),_vm._t("default"),_c('FootBar',{attrs:{"deviceType":_vm.deviceType}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }